<template>
  <span class="user-avatar" :class="`user-avatar-${size}`">
    {{ initials(name) }}
  </span>
</template>

<script setup lang="ts">
import { initials } from '../format';

withDefaults(defineProps<{
  name: string | null | undefined;
  size?: 'small' | 'medium' | 'large' | 'profile' | 'editor';
}>(), {
  size: 'medium'
});
</script>
